<template>
  <div>
    <el-row>
      <el-col :span="6">
        <el-card :body-style="cardBodyStyle">
          <el-button size="small" type="primary" plain @click="handleAddTop">新增顶级</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-tree :data="dataTree" :props="defaultProps" node-key="id" @node-click="handleNodeClick"
            :expand-on-click-node="false" highlight-current :default-expanded-keys="expandedKeys">
            <span class="custom-tree-node" slot-scope="{ node, data }">
              <span>{{ node.label }} </span>
              <span>

                <el-button v-if="data.children.length<1" type="text" size="mini"
                  @click="() => handleDelete(node, data)">
                  删除
                </el-button>
                <el-button type="text" size="mini" @click="() => handleEdit(node, data)">
                  编辑
                </el-button>
              </span>
            </span>
          </el-tree>
        </el-card>
      </el-col>
      <el-col :span="12">
        <el-card :body-style="cardBodyStyle">
          <el-button size="small" type="primary" plain @click="handleAdd">新增</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table v-loading="loading" :data="tableData" border @row-click="handleRowClick" highlight-current-row>
            <el-table-column prop="id" label="编号" width="50" v-if="isShow" header-align="center" align="center"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuPid" label="父编码" width="80" header-align="center" align="center"
              show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="menuCode" label="界面编码" width="110" header-align="center" align="center"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuName" label="界面名称" width="120" header-align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuOpenCs" label="Vue路由" width="150" header-align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuOpenBs" label="Vue路径" width="150" header-align="center" show-overflow-tooltip>
            </el-table-column>
            <!--            <el-table-column prop="menuOpenIos" label="IOS路径" width="150" header-align="center" show-overflow-tooltip>
            </el-table-column> -->
            <el-table-column prop="menuOpenAnd" label="APP路径" width="150" header-align="center" show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="menuAppOrder" label="APP排序" width="150" header-align="center" align="center"
              show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuAppImg" label="APP图片" width="150" header-align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="menuAppIcon" label="APP图标" width="150" header-align="center" align="center"
              show-overflow-tooltip>
            </el-table-column>

            <el-table-column prop="menuShow" label="是否显示" width="95" header-align="center" align="center"
              show-overflow-tooltip :formatter="typeFormatterShow">
            </el-table-column>
            <!--            <el-table-column prop="menuQuery" label="查询权限" width="95" header-align="center" align="center"
              show-overflow-tooltip :formatter="typeFormatterQuery">
            </el-table-column> -->
            <!--  <el-table-column label="操作" width="160=" header-align="center" align="center" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" plain @click="handleEdit(scope.row)">编辑</el-button>
                <el-button size="mini" plain type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="totalRows">
          </el-pagination>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card :body-style="cardBodyStyle">
          <el-button size="small" type="primary" plain @click="handleGenerate">生成</el-button>
          <el-button size="small" type="primary" plain @click="handleAddButton">自定义</el-button>
        </el-card>
        <el-card :body-style="cardBodyStyle">
          <el-table :data="tableDataButton" border>
            <el-table-column prop="buttonName" label="名称" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="area" label="位置" header-align="center" align="center" show-overflow-tooltip>
            </el-table-column>
            <el-table-column label="操作" header-align="center" align="center" width="160" fixed="right">
              <template slot-scope="scope">
                <el-button size="mini" plain type="warning" @click="handleModifyButton(scope.row)">编辑</el-button>
                <el-button size="mini" plain type="danger" @click="handleRemoveButton(scope.row)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>

    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisible" width="900px">
      <el-form :model="form" label-width="70px" :inline="true">
        <el-form-item label="id" v-if="false">
          <el-input v-model="form.id"></el-input>
        </el-form-item>
        <el-form-item label="上级编码">
          <el-input v-model="form.menuPid" size="small" disabled style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="界面编码">
          <el-input v-model="form.menuCode" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="界面名称">
          <el-input v-model="form.menuName" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="Vue路由">
          <el-input v-model="form.menuOpenCs" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="Vue路径">
          <el-input v-model="form.menuOpenBs" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <!-- <el-form-item label="bs图标">
            <el-input v-model="form.menuBsIcon" size="small" style="width: 200px;"></el-input>
          </el-form-item> -->
        <!-- <el-form-item label="ios路径">
            <el-input v-model="form.menuOpenIos" size="small" style="width: 200px;"></el-input>
          </el-form-item> -->
        <el-form-item label="APP路径">
          <el-input v-model="form.menuOpenAnd" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="APP排序">
          <el-input v-model="form.menuAppOrder" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="APP图片">
          <el-input v-model="form.menuAppImg" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="APP图标">
          <el-input v-model="form.menuAppIcon" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="是否显示">
          <el-radio-group v-model="form.menuShow" size="small" @change="handleRadioChangeShow" style="width: 200px;">
            <el-radio :label="0">是</el-radio>
            <el-radio :label="9">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="查询权限">
          <el-radio-group v-model="form.menuQuery" size="small" @change="handleRadioChangeQuery" style="width: 200px;">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item> -->
      </el-form>
      <span slot="footer">
        <el-button type="success" size="small" @click="handleSave">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSave">取消</el-button>
      </span>

    </el-dialog>


    <el-dialog :close-on-click-modal="false" v-dialogDrag :visible.sync="dialogVisibleButton" width="800px">
      <el-form :model="button" label-width="70px" :inline="true">
        <el-form-item label="id" v-if="false">
          <el-input v-model="button.id" size="small"></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="button.buttonName" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="事件">
          <el-input v-model="button.click" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="图标">
          <el-input v-model="button.icon" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="位置">
          <el-input v-model="button.area" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="button.sort" size="small" style="width: 200px;"></el-input>
        </el-form-item>
        <div>
          <el-form-item label="尺寸">
            <el-radio-group v-model="button.buttonSize" size="small" style="width: 500px;">
              <el-radio-button label="mini">mini</el-radio-button>
              <el-radio-button label="small">small</el-radio-button>
              <el-radio-button label="medium ">medium </el-radio-button>
              <el-radio-button label="large">large</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="类型">
            <el-radio-group v-model="button.buttonType" size="small" style="width: 500px;">
              <el-radio-button label="primary">primary</el-radio-button>
              <el-radio-button label="danger">danger</el-radio-button>
              <el-radio-button label="info">info</el-radio-button>
              <el-radio-button label="success">success</el-radio-button>
              <el-radio-button label="warning">warning</el-radio-button>
              <el-radio-button label="text">text</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </div>
        <el-form-item label="朴素">
          <el-radio-group v-model="button.plain" size="small">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="圆角">
          <el-radio-group v-model="button.round" size="small">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="圆形">
          <el-radio-group v-model="button.circle" size="small">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="禁用">
          <el-radio-group v-model="button.disabled" size="small">
            <el-radio-button :label="1">是</el-radio-button>
            <el-radio-button :label="0">否</el-radio-button>
          </el-radio-group>
        </el-form-item>

      </el-form>
      <span slot="footer">
        <el-button type="success" size="small" @click="handleSaveButton">保存</el-button>
        <el-button type="danger" size="small" @click="handleCancelSaveButton">取消</el-button>
      </span>


    </el-dialog>





  </div>
</template>

<script>
  import axios from '@/axios'
  import tools from '@/tools'
  export default {
    data() {
      return {
        cardBodyStyle: tools.style.card,

        dataTree: [],
        expandedKeys: [],


        defaultProps: {
          children: 'children',
          label: 'menuName'
        },
        tableData: [],
        currentPage: 1,
        totalRows: 0,
        pageSizes: [10, 20, 30, 40],
        pageSize: 10,


        selectedMenuId: '',
        selectedMenu: {},
        tableDataButton: [],
        button: {
          id: '',
          menuId: '',
          buttonName: '',
          buttonSize: 'mini',
          buttonType: 'primary',
          plain: 0,
          round: 0,
          circle: 0,
          loading: 0,
          disabled: 0,
          icon: '',
          autofocus: 0,
          click: '',
          sort: '',
        },
        //录入框
        dialogVisible: false,
        dialogVisibleButton: false,

        form: {
          id: '',
          menuPid: '',
          menuCode: '',
          menuName: '',
          menuBsIcon: '',
          menuOpenBs: '',

          menuOpenIos: '',
          menuOpenAnd: '',
          menuAppOrder: '',
          menuAppImg: '',
          menuAppIcon: '',

          menuShow: '',
          menuQuery: '',
        },
        isShow: false,
        loading: true,
        loadingTree: true,
      }
    },
    mounted() {
      this.getDataTree()
      this.getTableData()
    },
    methods: {
      typeFormatterShow: function(row, column) {
        switch (row.menuShow) {
          case 0:
            return "是";
            break;
          case 9:
            return "否";
            break;
        }
      },

      typeFormatterQuery: function(row, column) {
        switch (row.menuQuery) {
          case 1:
            return "是";
            break;
          case 0:
            return "否";
            break;
        }
      },
      getDataTree() {
        var url = 'framework/SysMenu/queryAllMenu.do'
        var param = {}
        axios.get(url, param).then(response => {
          this.dataTree = response.data.data
        });
      },
      handleRadioChangeShow(data) {
        this.form.menuShow = data
      },
      handleRadioChangeQuery(data) {
        this.form.menuQuery = data
      },
      handleNodeClick(data) {
        this.selectedMenu = data
        this.getTableData()
        this.expandedKeys = []
        this.expandedKeys.push(data.id)
      },
      getTableData() {
        //console.log("获取table数据getTableData")
        var url = 'framework/SysMenu/query.do'
        var param = {
          page: this.currentPage,
          rows: this.pageSize,
          pid: this.selectedMenu.menuCode,
        }
        axios.post(url, param).then(response => {
          this.tableData = response.data.data.list
          this.totalRows = response.data.data.total

          if (response) {
            this.loading = false
          } else {
            this.loading = true
          }
        });
      },
      // 修改每页条数事件
      handleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.pageSize = val
        this.getTableData()
      },
      // 修改当前页事件
      handleCurrentChange(val) {
        //	console.log(`当前页: ${val}`);
        this.currentPage = val
        this.getTableData()
      },

      handleAddTop() {
        this.dialogVisible = true
        this.form = {
          id: '',
          menuPid: '0',
          menuCode: '',
          menuName: '',
          menuBsIcon: '',
          menuOpenBs: '',
          menuOpenIos: '',
          menuOpenAnd: '',
          menuAppOrder: '',
          menuAppImg: '',
          menuAppIcon: '',
          menuShow: 0,
          menuQuery: 0,
        }

        var url = 'framework/SysMenu/queryNewCode.do'
        var param = {
          fid: '0'
        }
        axios.get(url, param).then(response => {
          this.form.menuCode = response.data.data.code
        });
      },
      handleAdd() {
        if (this.selectedMenu == null || this.selectedMenu.menuPid == null) {
          this.$message({
            type: 'error',
            message: '请选择上级菜单'
          });
          return
        }

        this.dialogVisible = true
        this.form = {
          id: '',
          menuPid: this.selectedMenu.menuCode,
          menuCode: '',
          menuName: '',
          menuBsIcon: '',
          menuOpenBs: '',

          menuOpenIos: '',
          menuOpenAnd: '',
          menuAppOrder: '',
          menuAppImg: '',
          menuAppIcon: '',

          menuShow: 0,
          menuQuery: 0,
        }

        var url = 'framework/SysMenu/queryNewCode.do'
        var param = {
          fid: this.form.menuPid
        }
        axios.get(url, param).then(response => {
          this.form.menuCode = response.data.data.code
        });

      },

      handleEdit(node, data) {
        this.dialogVisible = true
        this.form = data
      },

      handleSave(row) {
        var url = 'framework/SysMenu/save.do'
        var param = {
          json: JSON.stringify(this.form)
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '保存成功!',
            });
            this.getTableData()
            this.getDataTree()
            this.dialogVisible = false
          } else {
            this.$message({
              type: 'error',
              message: '保存失败' + response.data.msg,
            });
          }

        });
      },

      //保存取消按钮事件   关闭编辑对话框
      handleCancelSave(row) {
        this.dialogVisible = false
      },


      // 删除按钮事件
      handleDelete(node, data) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysMenu/remove.do'
          var param = {
            id: data.id
          }
          axios.post(url, param).then(response => {

            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '操作成功!',
              });
              this.getTableData()
              this.getDataTree()

            } else {
              this.$message({
                type: 'error',
                message: '保存失败' + response.data.msg,
              });
            }


          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },


      handleGenerate() {
        if (this.selectedMenuId == '') {
          this.$message({
            type: 'error',
            message: '请选择菜单',
          });
          return
        }
        var url = 'framework/SysMenu/generateButton.do'
        var param = {
          menuId: this.selectedMenuId
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '保存成功!',
            });
            this.queryMenuButton()
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },


      handleRowClick(row, column, event) {
        this.selectedMenuId = row.id
        this.queryMenuButton()
      },

      queryMenuButton() {
        var url = 'framework/SysMenu/queryMenuButton.do'
        var param = {
          menuId: this.selectedMenuId
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.tableDataButton = response.data.data
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });
      },

      handleAddButton() {
        if (this.selectedMenuId == '') {
          this.$message({
            type: 'error',
            message: '请选择菜单',
          });
          return
        }


        this.dialogVisibleButton = true
        this.button = {
          id: '',
          menuId: this.selectedMenuId,
          buttonName: '自定义',
          buttonSize: 'mini',
          buttonType: 'primary',
          plain: 0,
          round: 0,
          circle: 0,
          loading: 0,
          disabled: 0,
          icon: '',
          autofocus: 0,
          click: 'action',
          sort: this.tableDataButton.length + 1,
        }

      },
      handleSaveButton() {
        console.log(JSON.stringify(this.button))

        var url = 'framework/SysMenu/saveMenuButton.do'
        var param = {
          json: JSON.stringify(this.button)
        }
        axios.post(url, param).then(response => {
          if (response.data.code == '0') {
            this.$message({
              type: 'success',
              message: '保存成功!',
            });
            this.queryMenuButton()
            this.dialogVisibleButton = false
          } else {
            this.$message({
              type: 'error',
              message: '操作失败' + response.data.msg,
            });
          }
        });


      },
      handleCancelSaveButton() {
        this.dialogVisibleButton = false
      },
      handleModifyButton(row) {
        this.dialogVisibleButton = true
        this.button = row
      },
      handleRemoveButton(row) {
        this.$confirm('此操作将删除该数据, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var url = 'framework/SysMenu/removeMenuButton.do'
          var param = {
            id: row.id
          }
          axios.post(url, param).then(response => {
            if (response.data.code === 0) {
              this.$message({
                type: 'success',
                message: '保存成功!',
              });
              this.queryMenuButton()
              this.dialogVisibleButton = false
            } else {
              this.$message({
                type: 'error',
                message: '保存失败' + response.data.msg,
              });
            }
          });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      }
    }
  }
</script>
<style>
  .btn {
    padding-left: 15px;
  }


  .menu-tree-container {

    width: 20%;
    height: 100%;
    float: left;
    /* background: #e5e9f2; */
  }

  .menu-table-container {
    /* position: relative; */

    width: 60%;
    float: left;
    /* margin-right: 10px; */
    /* margin-top: -530px; */
    /* border: black 1px solid; */
  }

  .menu-button-container {
    /* position: relative; */

    width: 20%;
    float: right;
    /* margin-right: 10px; */
    /* margin-top: -530px; */
    /* border: black 1px solid; */
  }
</style>



// WEBPACK FOOTER //
// src/view/system/menu.vue